$('#ativa-barra-pesquisa') .on('click', function (){
$('#searchform') .toggleClass('d-none')
$('#ativa-barra-pesquisa') .toggleClass('d-none')
});
$('#menu-activate').on('click',function(){
$("#menu-header-tog").toggleClass('d-none');
});

$("#voltartopo").on('click', function() {
    $('html, body').animate({ scrollTop: 0 }, 'slow'); // 'slow' pode ser substituído por milissegundos, ex: 500
});
$("#whatsapp").on('click', function() {
    window.open("https://wa.me/551632346262", "_blank");
});
